import * as Actions from '../../actions';

const initialState = { data: null };

const productionStatsReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PRODUCTION_STATS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default productionStatsReducer;
